import React, { useEffect, useState, useContext, useRef } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import {FormValidator, useFormValidator, Inputs, Scrollable, Message } from "coaz-ui";
import { PiTrashLight } from "react-icons/pi";
import { LiaPlusSolid } from "react-icons/lia";
import client from '../client';
import RoleAuthorities from "./RoleAuthorities";

const AddRole = ({submitRef, setLoading, setEnableSubmit}) => {
	const [role, setRole] = useState({
		name: "",
		authorities: [],
	});
	const [addingAuthority, setAddingAuthority] = useState(false);
	const [selectedAuth, setSelectedAuth] = useState(null);
	const [addAuthority, setAddAuthority] = useState(null);
	const [message, setMessage] = useState({ content: "", success: false });
	const { request, errorMessage } = client;
	const minWidth = 240;
	const [inputWidth, setInputWidth] = useState(minWidth);
	const addButtonRef = useRef(null);

	/*Code added to properly manage loading state */
	useEffect(() => {
		setLoading && setLoading(true);
		const timer = setTimeout(() => {
			setLoading && setLoading(false);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	const submit = async (e) => {
		try {
            const response = await request('POST', 'roles', role);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
	};

	const [register, handleChange, handleSubmit, errors] =
		useFormValidator(submit);

	const inputs = [
		{
			label: "name",
			type: "text",
			name: "name",
			value: role && role.name ? role.name : "",
			placeholder: "Enter name...",
			onChange: (e) => {
				handleChange(e, onChange);
			},
			register: register,
			checks: ["empty"],
			errors: errors,
		}
	];

	const onChange = (e) => {
		const value = e.target.value;
		if (value === "") {
			setRole({ ...role, [e.target.name]: null });
		} else {
			setRole({ ...role, [e.target.name]: value });
		}
	};

	//const navigate = useNavigate();

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	return (
			<FormValidator>
				<div className="flex flex-col w-full h-auto">
					<div className="flex flex-col w-full h-auto space-y-4 shrink-0">
						<Inputs
							inputs={inputs}
							minWidth={minWidth}
							paddingX={0}
							spaceX={32}
							id="add_usertype"
							setCalcWidth={setInputWidth}
						/>
						<RoleAuthorities role={role} setRole={setRole} />
					</div>
				</div>
			</FormValidator>
	);
};

export default AddRole;
